import React, { useEffect, useState } from 'react'
import Modal from 'shared/components/ui/Modal'
import Button from 'shared/components/ui/button'
import { useAuth } from 'context/AuthContext'

function SessionExpiredModal() {
  const [open, setOpen] = useState(false)
  const { logout } = useAuth()

  useEffect(() => {
    const onExpire = () => setOpen(true)
    window.addEventListener('scanner:session-expired', onExpire)
    return () => window.removeEventListener('scanner:session-expired', onExpire)
  }, [])

  const handleLogin = async () => {
    await logout()
    setOpen(false)
    window.location.assign('/login')
  }

  return (
    <Modal open={open} onClose={handleLogin} title="Session expired">
      <p className="mb-5 text-muted">Session expired, please log in again.</p>
      <Button className="w-full" onClick={handleLogin}>
        Log in again
      </Button>
    </Modal>
  )
}

export default SessionExpiredModal
